import { useTranslations } from 'next-intl'

import { useRefundAccount } from '@/features/update-account'
import { useFormatDate } from '@/shared/lib'

type RefundAccountProps = {
  contractId: number
}

export const RefundAccount = ({ contractId }: RefundAccountProps) => {
  const t = useTranslations('refund_information')
  const { formatDateWithDayOfWeek } = useFormatDate()

  const { isRefunded, refundAccount, refundedAt } = useRefundAccount({
    contractId,
  })

  return (
    <div className="space-y-3">
      <h3 className="typo-body1 font-semibold text-black">
        {t('refund_account.label')}
      </h3>

      {(() => {
        if (isRefunded) {
          return (
            <div className="space-y-2">
              <p className="typo-label1 font-medium text-gray-900">
                {refundAccount}
              </p>
              <p className="typo-body1 font-bold text-purple-500">
                {t('refund_status.completed', {
                  date: formatDateWithDayOfWeek({
                    date: refundedAt!,
                  }),
                })}
              </p>
            </div>
          )
        }

        return (
          <p className="typo-label1 font-medium text-gray-900">
            {refundAccount}
          </p>
        )
      })()}
    </div>
  )
}
